import { render, staticRenderFns } from "./RegistrationPatient.vue?vue&type=template&id=640698d5&scoped=true&"
import script from "./RegistrationPatient.vue?vue&type=script&lang=js&"
export * from "./RegistrationPatient.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationPatient.vue?vue&type=style&index=0&id=640698d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640698d5",
  null
  
)

export default component.exports